import React from 'react'
import ReactGA from 'react-ga'
import styled, { css } from 'styled-components'

// import Modal from './Modal'
// import { MiniChart } from "react-tradingview-embed"
// import YouTube from 'react-youtube'
import AdSense from 'react-adsense'
import qs from 'query-string'
import { Helmet } from "react-helmet"
import { useWindowSize } from 'react-hooks-window-size'

import marketCoins from '../markets'
import twitters from '../twitters'

import HomeHeader from './HomeHeader'

import LiveTwittersWidget from '../widgets/LiveTwittersWidget'
import DetailChartsWidget from '../widgets/DetailChartsWidget'
import DashboardWidget from '../widgets/DashboardWidget'
import CrossWidgets from '../widgets/CrossWidgets'
import TableWidget from '../widgets/TableWidget'
import TimelineWidget from '../widgets/TimelineWidget'
import RbiTreeWidget from '../widgets/RbiTreeWidget'

const Page = styled.div`
  max-width: 1700px; min-width: 1700px; margin: 1rem auto;
  padding-bottom: 8rem;
`

Page.Grid = styled.div`
  position: relative; display: flex;
  & > * { margin: 10px; }
  & > div.aside {
    display: block; position: absolute; transition: all 0.3s;
    @media screen and (max-width: 2000px) { display: none; }
  }
`

Page.ChartButtons = styled.div`
  position: relative;
  & > div {
    display: flex;
    max-width: 100%; margin: 0 auto;
    background: white; overflow: auto; flex-wrap: nowrap;
    border-radius: 0.35rem;
    & > a {
      color: #121214; min-width: max-content;
      font-weight: 700;
      display: block; color: 
      white-space: pre; padding: 0.55rem 0.85rem;
      &.active {
        background: skyblue;
        &:hover { opacity: 1; }
      }
      &:hover { opacity: 1; }
    }
  }
`

Page.Cover = styled.div`
  position: fixed; left: 0; top: 0;
  width: 100%; height: 100%; z-index: 8999;
  background: #111; opacity: 0.97;
`

Page.Drawer = styled.div`
  position: fixed; left: 50%; margin-left: -820px; bottom: 0;
  padding: 10px; transition: all 0.3s;
  min-width: 1640px; max-width: 1640px; height: 100px; max-height: 100px;
  overflow: hidden; cursor: pointer;
  border-top-left-radius: 0.35rem; overflow-y: hidden;
  border-top-right-radius: 0.35rem;
  z-index: 9999; background: rgba(1,1,1, 0.99);
  &.active { bottom: 0; background: #141722; height: 800px; max-height: 800px; overflow-y: scroll; }
  & > div {
    position: relative; box-sizing: border-box;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`

Page.Header = styled.header`
  position: relative; font-size: 1.5rem; padding: 1rem;
  display: flex; justify-content: space-between;
`

Page.Message = styled.header`
  position: relative; padding: 1rem;
  display: flex; justify-content: space-between;
  & > a { font-weight: 700; color: yellow; }
  & > div:first-child { flex: 1 1 100%; }
  & > div:last-child { min-width: max-content; white-space: pre-line; }
`

const Block = styled.header`
  position: relative;  padding: 0.5rem;
  & > header { font-size: 1.5rem; padding: 1rem 0; }
`

const Home = ({ match = {} }) => {
  ReactGA.pageview(window.location.pathname + window.location.search)

  const search = window.location.search ? qs.parse(window.location.search) : {}

  const initialMarket = (match.params || { market: null }).market
    ? decodeURIComponent(match.params.market)
    : (search.market ? decodeURIComponent(search.market) : 'CRYPTOCAP:TOTAL')

  if (search.mode) { window.localStorage.setItem('mode',  search.mode) }
  const mode = window.localStorage.getItem('mode') || 'trade'

  const [symbol, setSymbol] = React.useState(initialMarket)
  const goSymbol = (symbol) => [window.localStorage.setItem('mode', 'trade'), window.location.href = `/${encodeURIComponent(symbol)}`]
  const size = useWindowSize() // size.width
  const [adsenseLoaded, setAdsenseLoaded] = React.useState(true)

  const getTwitter = (symbol) => {
    const name = symbol.replace('UPBIT:', '').replace('KRW', '')
    return twitters.find(t => t.market === `KRW-${name}`)
  }

  // 최초 팝업 구성
  // if (!window.localStorage.getItem('connectCount')) {
  //   window.localStorage.setItem('connectCount', 1)
  // } else {
  //   const connectCount = window.localStorage.getItem('connectCount')
  //   window.localStorage.setItem('connectCount', connectCount*1 + 1)
  // }
  // const isFirst = () => window.localStorage.getItem('connectCount') * 1 < 10
  // const [modal, setModal] = React.useState(initialMarket === 'CRYPTOCAP:TOTAL' ? 'welcomeModal' : '')
  
  // 현재 접속한 마켓에 대한 정보를 저장하기
  let currentMarket = false, currentCoin = initialMarket && initialMarket !== 'CRYPTOCAP:TOTAL' ? initialMarket.replace('UPBIT:', '').replace('KRW', '') : false
  if (currentCoin) { currentMarket = marketCoins.find(coin => coin.market === `KRW-${currentCoin}`) }

  // 트레이딩모드에 대한 값 지정하기
  const lChartSet = window.localStorage.getItem('lChartSet') || 'basic'
  const lChartSet2 = window.localStorage.getItem('lChartSet2') || 'basic'
  const lChartSet3 = window.localStorage.getItem('lChartSet3') || 'basic'
  const lChartSet4 = window.localStorage.getItem('lChartSet4') || 'basic'

  // 타점맵오픈기능
  const [dashboardDrawer, setDashboardDrawer] = React.useState(false)

  return (
    <Page>
      <Helmet>
        {currentMarket && mode === 'trade' ? <title>{currentMarket.korean_name}({currentMarket.english_name}, {currentCoin}) 암호화폐 고래·타점 코알(코인알비아이)</title> : null}
        {mode === 'view' ? <title>암호화폐 고래·타점 코알 - 코인 트랜드</title> : null}
        {mode === 'static' ? <title>암호화폐 고래·타점 코알 - 시장분석 보고서</title> : null}
      </Helmet>

      {/* <Modal
        isOpen={isFirst() && modal === 'welcomeModal'}
        onRequestClose={() => setModal(null)}
        customStyles={{ content: {
          top: '50%', left: '50%', right: 'auto', bottom: 'auto',
          maxWidth: 'max-content',
          marginRight: '-50%', transform: 'translate(-50%, -50%)'
        } }}
      >
          <img src="/welcome_beginer.jpg" style={{ height: '580px', cursor: 'pointer' }} onClick={e => [e.stopPropagation(), e.preventDefault(), window.open(`https://cafe.naver.com/coinrbi/3045`), setModal(null)]} />
      </Modal> */}

      <HomeHeader />

      <div style={{ padding: '0.75rem' }}>
        <Page.ChartButtons>
          <div>
            {currentMarket && (currentMarket.market.indexOf('KRW-BTC') < 0)
              ? (<a href="#updateChartSymbol" className={symbol.indexOf(`UPBIT:${currentCoin}KRW`) === 0 ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol(symbol)]}>🎯 {currentMarket.korean_name} <small>차트</small></a>)
              : null}

            <a href="#updateChartSymbol" className={symbol === 'CRYPTOCAP:TOTAL' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('CRYPTOCAP:TOTAL')]}>🌎 시가총액</a>
            <a href="#updateChartSymbol" className={symbol === '1/CRYPTOCAP:BTC.D*FOREXCOM:NSXUSD*BITFINEX:BTCUSDLONGS/BITFINEX:BTCUSDSHORTS' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('1/CRYPTOCAP:BTC.D*FOREXCOM:NSXUSD*BITFINEX:BTCUSDLONGS/BITFINEX:BTCUSDSHORTS')]}>🚥 종합판세</a>
            <a href="#updateChartSymbol" className={symbol === 'BINANCEUS:BTCUSDT' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('BINANCEUS:BTCUSDT')]}>🍔 버거대장</a>
            <a href="#updateChartSymbol" className={symbol === 'UPBIT:BTCKRW' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('UPBIT:BTCKRW')]}>🥓 김치대장</a>
            <a href="#updateChartSymbol" className={symbol === 'BITFINEX:BTCUSDSHORTS/BITFINEX:BTCUSDLONGS' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('BITFINEX:BTCUSDSHORTS/BITFINEX:BTCUSDLONGS')]}>🪓 롱숏</a>
            <a href="#updateChartSymbol" className={symbol === 'UPBIT:BTCKRW/BITHUMB:BTCKRW' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('UPBIT:BTCKRW/BITHUMB:BTCKRW')]}>🥊 업비트/빗썸</a>
            <a href="#updateChartSymbol" className={symbol === 'CRYPTOCAP:BTC.D' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('CRYPTOCAP:BTC.D')]}>🍕 비트도미</a>
            <a href="#updateChartSymbol" className={symbol === 'CRYPTOCAP:USDT.D' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('CRYPTOCAP:USDT.D')]}>🔥 테더도미</a>
            <a href="#updateChartSymbol" className={symbol === 'CRYPTOCAP:OTHERS.D' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('CRYPTOCAP:OTHERS.D')]}>🌱 알트도미</a>
            <a href="#updateChartSymbol" className={symbol === 'FOREXCOM:NSXUSD' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('FOREXCOM:NSXUSD')]}>🥰 나스닥테크탑100</a>
            <a href="#updateChartSymbol" className={symbol === 'BITFINEX:BTCUSDLONGS' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('BITFINEX:BTCUSDLONGS')]}>🌋 롱</a>
            <a href="#updateChartSymbol" className={symbol === 'BITFINEX:BTCUSDSHORTS' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('BITFINEX:BTCUSDSHORTS')]}>🌊 숏</a>
            <a href="#updateChartSymbol" className={symbol === 'BITMEX:XBTUSD' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('BITMEX:XBTUSD')]}>🐋 비맥 XBT</a>
            <a href="#updateChartSymbol" className={symbol === 'TSX:BITI' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('TSX:BITI')]}>🧛‍♂️ BITI</a>
            <a href="#updateChartSymbol" className={symbol === 'FX_IDC:USDKRW' ? 'active' : ''} onClick={e => [e.preventDefault(), goSymbol('FX_IDC:USDKRW')]}>💸 환율</a>
          </div>
        </Page.ChartButtons>
      </div>

      {mode === 'trade' && (symbol.indexOf('/') < 0) && symbol.indexOf('UPBIT:') === 0 && currentMarket ? <TableWidget pick={currentMarket} /> : null}
      
      {mode === 'trade' ? (
        <Page.Grid>
          <div className="animate__animated animate__fadeInLeft" style={{ animationDelay: `${2}s`, width: (symbol.indexOf('/') < 0) ?'830px' : '100%', height: '750px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <a
                href="#lChartSet"
                onClick={e => {
                  window.localStorage.setItem('lChartSet', 'basic')
                  return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                }}
                style={lChartSet === 'basic' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
              >
                MACD
              </a>
              <a
                href="#lChartSet"
                onClick={e => {
                  window.localStorage.setItem('lChartSet', 'rsi')
                  return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                }}
                style={lChartSet === 'rsi' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
              >
                RSI
              </a>
              <a
                href="#lChartSet"
                onClick={e => {
                  window.localStorage.setItem('lChartSet', 'wr')
                  return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                }}
                style={lChartSet === 'wr' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
              >
                W%R
              </a>
              <a
                href="#lChartSet"
                onClick={e => {
                  window.localStorage.setItem('lChartSet', 'obv')
                  return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                }}
                style={lChartSet === 'obv' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
              >
                OBV
              </a>
              <a
                href="#lChartSet"
                onClick={e => {
                  window.localStorage.setItem('lChartSet', 'all')
                  return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                }}
                style={lChartSet === 'all' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
              >
                ALL
              </a>
            </div>
            <iframe src={`/chart?name=${symbol}&interval=${(symbol.indexOf('/') < 0) ?'240' : '1D'}&width=${(symbol.indexOf('/') < 0) ? `830` : `1680`}&height=600&chartSet=${lChartSet}&hiddenSidebar=false`} height={610} width={(symbol.indexOf('/') < 0) ? 830 : `100%`} frameBorder={0} />
            {((symbol) => {
              if (symbol === 'CRYPTOCAP:TOTAL') {
                return <div style={{ padding: '0.5rem 0' }}>🧙 <strong>암호화폐 시장의 총시총액</strong><br/>1T 당 약 1,100조원 수준이며 🔴하락시 시장 자금유출이 있는지 체크 🟢상승시 비트와 알트에 자금이 유입됨을 의미합니다. </div>
              }
              if (symbol === '1/CRYPTOCAP:BTC.D*FOREXCOM:NSXUSD*BITFINEX:BTCUSDLONGS/BITFINEX:BTCUSDSHORTS') {
                return <div style={{ padding: '0.5rem 0' }}>🚥 <strong>종합판세..."빨간불이야, 파란불이야"</strong><br/>매매를 하려다가도 장기판세는 어떤지, 단기 판세는 어떤지 햇갈리신다면 장기판세를 검증해보세요. 골든크로스시 매수 트라이지점, 데드크로스시 매도 트라이지점으로 판단해볼 수 있습니다. 선물장 나스닥 지수 도미넌스 기반입니다.</div>
              }
              if (symbol === 'UPBIT:BTCKRW/BITHUMB:BTCKRW') {
                return <div style={{ padding: '0.5rem 0' }}>🥊 <strong>업비트 대 빗썸..."김치대장 뚝배기 싸움"</strong><br/>업비트와 빗썸 모두 상장된 코인이 있는 경우에 격차가 벌어질때 해당 페어링된 코인들의 입출금 간격이 벌어지거나 한쪽에서 지갑이 닫히는 현상이 있을때 가두리양식이 벌어지거나 역전차이가 발생합니다. 골든크로스를 체크해보세요. 1에 근접할수록 업비트가 높은쪽 -1에 근접할수록 빗썸 비트코인이 비싸진 상태를 의미합니다. 빗썸이 상대적으로 위험도 높은 신규자산이 상장되는 경우가 많아 신규상장 시기 또는 좀 더 알트나 BTC장이 활성화 되는 시기에 강세일 수 있습니다.</div>
              }
              if (symbol === 'BITFINEX:BTCUSDSHORTS/BITFINEX:BTCUSDLONGS') {
                return <div style={{ padding: '0.5rem 0' }}>🪓 <strong>롱 대 숏..."살짝만 스쳐도 우린 인연이 아닌, 청산"</strong><br/>숏의 비율이 줄고 롱의 비율이 늘때의 상태는 결국 롱을 매수하기 좋은 위치인 충분히 저점이 나온 위치로 판단해볼 수 있습니다. 이는 롱 미체결수가 급속도로 늘 수 있는점과 숏이 줄어야할 이유(*선물만기일, 주식 옵션 만기일, 세마녀의 날 등) 변동성이 심화되는 시기에 대한 기준이 있을 때 발생됩니다.</div>
              }
              return <div style={{ padding: '0.5rem 0' }}>👨‍🍳 <strong>좌편차트</strong><br/>편의상 장기봉(4시봉 ~ 주봉)을 켜두시면서 체크해보세요.</div>
            })(symbol)}
          </div>
        
          {symbol !== 'CRYPTOCAP:TOTAL' && (symbol.indexOf('/') < 0) ? (
            <>
              <div className="animate__animated animate__fadeInRight" style={{ animationDelay: `${2}s`, width: '830px', height: '750px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <a
                    href="#lChartSet2"
                    onClick={e => {
                      window.localStorage.setItem('lChartSet2', 'basic')
                      return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                    }}
                    style={lChartSet2 === 'basic' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
                  >
                    MACD
                  </a>
                  <a
                    href="#lChartSet2"
                    onClick={e => {
                      window.localStorage.setItem('lChartSet2', 'rsi')
                      return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                    }}
                    style={lChartSet2 === 'rsi' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
                  >
                    RSI
                  </a>
                  <a
                    href="#lChartSet2"
                    onClick={e => {
                      window.localStorage.setItem('lChartSet2', 'wr')
                      return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                    }}
                    style={lChartSet2 === 'wr' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
                  >
                    W%R
                  </a>
                  <a
                    href="#lChartSet2"
                    onClick={e => {
                      window.localStorage.setItem('lChartSet2', 'obv')
                      return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                    }}
                    style={lChartSet2 === 'obv' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
                  >
                    OBV
                  </a>
                  <a
                    href="#lChartSet2"
                    onClick={e => {
                      window.localStorage.setItem('lChartSet2', 'all')
                      return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                    }}
                    style={lChartSet2 === 'all' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
                  >
                    ALL
                  </a>
                </div>
                <iframe src={`/chart?name=${symbol}&interval=1&width=830&height=600&chartSet=${lChartSet2}&hiddenSidebar=false`} height={610} width={830} frameBorder={0} />
                <div style={{ padding: '0.5rem 0', textAlign: 'right' }}>🕵️‍♂️ <strong>우편차트</strong><br/>편의상 단기봉(1분 ~ 15분봉)을 켜두시면서 체크해보세요.</div>
              </div>
            </>
          ) : null}
          
          {symbol === 'CRYPTOCAP:TOTAL' ? (
            <>
              <div className="animate__animated animate__fadeInRight" style={{ animationDelay: `${2}s`, width: '830px', height: '750px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <a
                    href="#lChartSet3"
                    onClick={e => {
                      window.localStorage.setItem('lChartSet3', 'basic')
                      return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                    }}
                    style={lChartSet3 === 'basic' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
                  >
                    MACD
                  </a>
                  <a
                    href="#lChartSet3"
                    onClick={e => {
                      window.localStorage.setItem('lChartSet3', 'rsi')
                      return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                    }}
                    style={lChartSet3 === 'rsi' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
                  >
                    RSI
                  </a>
                  <a
                    href="#lChartSet3"
                    onClick={e => {
                      window.localStorage.setItem('lChartSet3', 'wr')
                      return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                    }}
                    style={lChartSet3 === 'wr' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
                  >
                    W%R
                  </a>
                  <a
                    href="#lChartSet3"
                    onClick={e => {
                      window.localStorage.setItem('lChartSet3', 'obv')
                      return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                    }}
                    style={lChartSet3 === 'obv' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
                  >
                    OBV
                  </a>
                  <a
                    href="#lChartSet3"
                    onClick={e => {
                      window.localStorage.setItem('lChartSet3', 'all')
                      return [e.stopPropagation(), e.preventDefault(), window.location.reload()]
                    }}
                    style={lChartSet3 === 'all' ? { fontWeight: '900', color: 'yellow', padding: '0.5rem 0.75rem' } : { padding: '0.5rem 0.75rem' }}
                  >
                    ALL
                  </a>
                </div>
                <iframe src={`/chart?name=BINANCEUS:BTCUSDT&interval=1&width=830&height=600&chartSet=${lChartSet3}&hiddenSidebar=false`} height={610} width={830} frameBorder={0} />
                <div style={{ padding: '0.5rem 0', textAlign: 'right' }}>🕵️‍♂️ <strong>해외 비트코인 차트</strong><br/>한국 프리미엄을 제외한 상태의 순수추세를 볼 수 있어 업비트 반영보다 약간 빠르게 시장을 점검 할 수 있습니다.</div>
              </div>
            </>
          ) : null}
        </Page.Grid>
      ) : null}
      
      {mode === 'trade' && symbol === 'CRYPTOCAP:TOTAL'
        ? (<Page.Grid>
          <DetailChartsWidget />
        </Page.Grid>) : null}

      {mode === 'trade' && symbol === 'CRYPTOCAP:TOTAL' ? (
        <>
          <Page.Header>
            <div className="site">
              <strong>암호화폐</strong> 타점현황 <small>🚅 골든크로스 🏃 데드크로스</small>
            </div>
          </Page.Header>
          <Page.Grid>
            <div style={{ flex: '1 1 100%' }}>
              <CrossWidgets
                handleCoin={(name, stay, event) => {
                  window.localStorage.setItem('mode', 'trade')
                  if (stay === 'state') {
                    setSymbol(name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`)
                  } else if (stay === 'href' && event) {
                    event.target.href = `/${name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`}`
                  } else {
                    window.location.href= `/${name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`}`
                  }
                }}
              /> 
            </div>
          </Page.Grid>
        </>
        ) : null}
        
      <Page.Grid>
        <div style={{ flex: '1 1 100%', borderRadius: '0.35rem', padding: '1rem 0', background: '#0b0c11', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div>
            {/* {adsenseLoaded ? <AdSense.Google client='ca-pub-2415806529829125' slot='9103933123' style={{ display: 'block', width: 320 }} format='rectangle' /> : null} */}
            <img
              src="/ad_1.jpg"
              style={{ borderRadius: '0.5rem', cursor: 'pointer' }}
              onClick={e => {
                ReactGA.event({ category: 'adLink', action: `OutAd`, label: 'L12 스타일코인' })
                return window.open('https://t.me/stylecointeam')
              }}
            />
          </div>
        </div>
        <div style={{ flex: '1 1 100%', borderRadius: '0.35rem', padding: '1rem 0', background: '#0b0c11', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div>
            {adsenseLoaded ? <AdSense.Google client='ca-pub-2415806529829125' slot='1487663955' style={{ display: 'block', width: 320 }} format='rectangle' /> : null}
          </div>
        </div>
        <div style={{ flex: '1 1 100%', borderRadius: '0.35rem', padding: '1rem 0', background: '#0b0c11', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div>
            {adsenseLoaded ? <AdSense.Google client='ca-pub-2415806529829125' slot='3587213680' style={{ display: 'block', width: 320 }} format='rectangle' /> : null}
          </div>
        </div>
        <div style={{ flex: '1 1 100%', borderRadius: '0.35rem', padding: '1rem 0', background: '#0b0c11', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div>
            {adsenseLoaded ? <AdSense.Google client='ca-pub-2415806529829125' slot='8751910452' style={{ display: 'block', width: 320 }} format='rectangle' /> : null}
          </div>
        </div>
      </Page.Grid>
      
      {mode === 'trade' && symbol !== 'CRYPTOCAP:TOTAL' ? (
        <div>
          <LiveTwittersWidget name={getTwitter(symbol) ? getTwitter(symbol).twitter : null} />
          <LiveTwittersWidget target="speical" />
          <LiveTwittersWidget target="media" />
        </div>
      ) : null}

    <Page.Grid>
      <div style={{ flex: '1 1 100%' }}>
        <RbiTreeWidget 
          handleCoin={(name, stay, event) => {
            window.localStorage.setItem('mode', 'trade')
            if (stay === 'state') {
              setSymbol(name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`)
            } else if (stay === 'href' && event) {
              event.target.href = `/${name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`}`
            } else {
              window.location.href= `/${name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`}`
            }
          }}
        />
      </div>
      <div style={{ flex: '1 1 100%' }}>
        <TableWidget
          handleCoin={(name, stay, event) => {
            window.localStorage.setItem('mode', 'trade')
            if (stay === 'state') {
              setSymbol(name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`)
            } else if (stay === 'href' && event) {
              event.target.href = `/${name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`}`
            } else {
              window.location.href= `/${name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`}`
            }
          }}
        /> 
        <div style={{ padding: '0.5rem' }}>
          <header style={{ paddingBottom: '0.85rem', fontSize: '1.2rem' }}>
            <strong>타점랭킹이란?</strong>
          </header>
          <div>
            전일대비가 아닌, MACD 타점 기준으로 상하방 점수를 구성하여 보여드리는 랭킹(순위)입니다. 업비트의 전일대비와는 차이가 있습니다. 현재 -3%인 코인이 타점이 긍정적이여서 전일대비 2%까지 올라갔다 가정한다면, 사실상 5%입니다. 이점처럼 전일대비에 의지하지 않고, 타점의 상승 가능성을 두고 매매하는 방식입니다. ⚫ 하락, ⚪ 상방, 🟢 골든, 🔴 데드를 의미합니다. 데드와 껴있거나 하방추세가 껴있는 신호가 있다면 해당 시기를 피해서 매수하는 것도 좋은 방법이겠습니다.
          </div>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <header style={{ paddingBottom: '0.85rem', fontSize: '1.2rem' }}>
            <strong>사용방법</strong>
          </header>
          <div>
              순위가 높은 종목의 경우는 현재 가격대의 1-2틱 낮은 가격으로 진입하여 짧은 익절구간을 목표로 사용할 수 있습니다. 반대로 낮은 순위는 저점(5틱 ~ 15틱 이하)매매를 권하며 다소 긴 데이, 주간 스윙 등을 할 때 사용하세요. 흰색 테두리시 단기 최저가, 노란 테두리시 장기 최저가를 의미합니다. 매수힘은 없을 수 있으나 최저가 형성이 된 코인은 저점 매수 전략을 시도해볼 수 있습니다.
          </div>
        </div>
      </div>
    </Page.Grid>
        
      {dashboardDrawer ? <Page.Cover onClick={e => [e.stopPropagation(), setDashboardDrawer(false)]} /> : null}

      {mode === 'trade' ? (
        <Page.Drawer
          className={dashboardDrawer ? "active" : null}
          onClick={e => {
            if (!dashboardDrawer) { setDashboardDrawer(true) }
            return [e.stopPropagation()]
          }}
        >
          <DashboardWidget
            market={initialMarket}
            isWide={size.width * 1 >= 2000}
            handleCoin={(name, stay, event) => {
              window.localStorage.setItem('mode', 'trade')
              if (stay === 'state') {
                  setSymbol(name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`)
              } else if (stay === 'href' && event) {
                event.target.href = `/${name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`}`
              } else {
                window.location.href= `/${name ? `UPBIT:${name}KRW` : `CRYPTOCAP:TOTAL`}`
              }
            }}
          />
          </Page.Drawer>
      ) : null}
      
      {mode === 'trade' && symbol === 'CRYPTOCAP:TOTAL' ? (
        <>
          <Page.Grid>
            <div style={{ flex: '1 1 100%' }}>
              <TimelineWidget />
            </div>
          </Page.Grid>
        </>
        ) : null}

      {mode === 'static' && symbol === 'CRYPTOCAP:TOTAL' ? (
        <>          
          <Page.Grid>
            <div style={{ flex: '1 1 100%', borderRadius: '0.35rem' }}>
              <div style={{ padding: '1rem' }}><strong>도미넌스 히트맵(코인 시장의 점유율 및 지배력을 체크)</strong><br />검정색 그룹을 누르셔도 좋고, 노란색으로 커서가 잡힐때 휠을 위로 돌려주시면 확대됩니다.</div>
              <iframe src="https://coin360.com/widget/map.html?utm_source=embed_map" frameborder="0" title="Coin360.com: Cryptocurrency Market State" width="100%" height="600"></iframe>
            </div>
          </Page.Grid>
          
          <Page.Grid>
            <div style={{ flex: '1 1 100%', borderRadius: '0.35rem' }}>
              <div style={{ padding: '1rem' }}><strong>시총트리맵(코인의 덩치를 알아볼 수 있음)</strong><br />각 코인의 총시총 금액의 성장과정을 살펴볼 수 있습니다.</div>
              <iframe src={`/hitmap.html`} height={680} width="100%" frameBorder={0} />
            </div>
          </Page.Grid>

          <Page.Grid>
            <Block style={{ padding: '1rem' }}>
              <header>
                <strong>각 코인별 공식 트위터 모음</strong>
              </header>
              <div>
                <div style={{ padding: '0.5rem 0' }}>
                  각 코인별 재단 및 단체 및 회사 공식 트위터 모음입니다. 금융정보분석원(FIU), 특정금융거래정보의보고및이용등에관한법률(특금법)에 따라 가상자산사업자 신고, 정보보호 관리체계(ISMS)를 정식적으로 마친 1호 업비트 거래소의 원화상장 기준으로 구성하였습니다. 총 {marketCoins.length}종 종목을 분단위로 체크합니다.
                </div>
              </div>
              <div>
                <div style={{ padding: '0.5rem 0' }}>
                  <ul style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {marketCoins.map((marketCoin, idx) => {
                      return (
                        <li
                          key={`${idx}`}
                          onClick={e => {
                            const { twitter } = twitters.find(t => t.market === marketCoin.market) || { twitter : null }
                            if (!twitter) { return alert(`트위터 준비중입니다.`) }
                            ReactGA.event({ category: 'twitterLink', action: `OutTwitter`, label: twitter })
                            window.open(`https://twitter.com/${twitter}`)
                          }}
                          style={{ display: 'flex', alignItems: 'center', boxSizing: 'border-box', flex: '1 1 100%', minWidth: '23%', maxWidth: '23%', padding: '0.1rem 0', margin: '0.25rem 0.5%', cursor: 'pointer', background: '#333', borderRadius: '0.5rem', overflow: 'hidden' }}
                        >
                          <div style={{ padding: '1rem' }}>
                            <img
                              src={`https://api.coinrbi.com/symbols/${marketCoin.market.replace('KRW-', '')}.png`}
                              style={{ width: '30px' }}
                              alt={`${marketCoin.korean_name}(${marketCoin.english_name}, ${marketCoin.market.replace('KRW-', '')})`}
                              title={`${marketCoin.korean_name}(${marketCoin.english_name}, ${marketCoin.market.replace('KRW-', '')})`}
                            />
                          </div>
                          <div style={{ padding: '1rem 0' }}>
                            <strong style={{ color: 'white', marginRight: '0.15rem' }}>{marketCoin.market.replace('KRW-', '')}</strong><br />
                            <small style={{ color: '#929394', marginRight: '0.15rem', fontSize: '0.7em' }}>{marketCoin.korean_name}</small><br />
                            <small style={{ color: '#929394', fontSize: '0.7em' }}>{marketCoin.english_name}</small>
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            </Block>
            <Block style={{ minWidth: '420px', maxWidth: '420px' }}>              
              <div style={{ width: '420px' }}>
                {adsenseLoaded ? <AdSense.Google client='ca-pub-2415806529829125' slot='5872438584' style={{ display: 'block', width: 420 }} format='rectangle' /> : null}
              </div>
              
              <header>
                <strong>추천 암호화폐 바로가기 모음</strong>
              </header>
              <div style={{ paddingBottom: '0.5rem' }}>
                사람들은 어떻게 지금 시황을 볼까 궁금하다면 꼭 들려보세요. 모두 시황과 아이디어 교류하기 좋은 커뮤니티입니다 :)
              </div>
              <div style={{ padding: '1rem' }}>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.fmkorea.com/coin"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Fmkorea` }), window.open('https://www.fmkorea.com/coin')]
                    }}
                  >
                    ⚽ <strong>에펨코리아 가상화폐</strong> 게시판
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://gall.dcinside.com/board/lists?id=bitcoins_new1"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `DC BitCoin` }), window.open('https://gall.dcinside.com/board/lists?id=bitcoins')]
                    }}
                  >
                    👑 디시인사이드 <strong>비트코인 갤러리</strong>
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://gall.dcinside.com/mgallery/board/lists/?id=coin"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `DC AltCoins` }), window.open('https://gall.dcinside.com/mgallery/board/lists/?id=coin')]
                    }}
                  >
                    🐣 디시인사이드 <strong>알트 갤러리</strong>
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.ppomppu.co.kr/zboard/zboard.php?id=bitcoin"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `뽐뿌` }), window.open('https://www.ppomppu.co.kr/zboard/zboard.php?id=bitcoin')]
                    }}
                  >
                    📱 뽐뿌 <strong>가상화폐 게시판</strong>
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.clien.net/service/board/cm_vcoin"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `클리앙` }), window.open('https://www.clien.net/service/board/cm_vcoin')]
                    }}
                  >
                    💻 클리앙 <strong>가상화폐당</strong>
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://coinpan.com/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Coinpan` }), window.open('https://coinpan.com')]
                    }}
                  >
                    🐋 코인판 <strong>공식 웹사이트</strong>
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://kimpga.com/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `김프가` }), window.open('https://kimpga.com/')]
                    }}
                  >
                    🚨 김프가 <strong>김치 프리미엄 확인</strong>
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="http://mlbpark.donga.com/mp/b.php?search_select=sct&search_input=&select=spf&m=search&b=bullpen&query=%EC%BD%94%EC%9D%B8"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `MLBPARK` }), window.open('http://mlbpark.donga.com/mp/b.php?search_select=sct&search_input=&select=spf&m=search&b=bullpen&query=%EC%BD%94%EC%9D%B8')]
                    }}
                  >
                      ⚾ MLBPARK <strong>코인 게시판</strong>
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.instiz.net/name?category=102"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Instiz` }), window.open('https://www.instiz.net/name?category=102')]
                    }}
                  >
                    🩰 인스티즈 <strong>익명잡담 코인방</strong>
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://cafe.naver.com/nexontv"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Naver Cafe BITMAN` }), window.open('https://cafe.naver.com/nexontv')]
                    }}
                  >
                    ☕ 비트맨 <strong>네이버 대표카페</strong>
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.ddengle.com/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `DDENGLE` }), window.open('https://www.ddengle.com')]
                    }}
                  >
                    ⛏ 땡글닷컴 <strong>채굴 커뮤니티</strong>
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://quasarzone.com/bbs/qf_cryptocurrency"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Quasarzone` }), window.open('https://quasarzone.com/bbs/qf_cryptocurrency')]
                    }}
                  >
                    💻 퀘이사존 <strong>채굴 공간</strong>
                  </a>
                </div>
              </div>

              <header>
                <strong>추천 미디어·메스컴 링크</strong>
              </header>
              <div style={{ padding: '1rem' }}>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://kr.coinness.com/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `코인니스` }), window.open('https://kr.coinness.com/')]
                    }}
                  >
                    📰 <strong>코인니스</strong> 가상화폐 뉴스피드
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://cobak.co.kr/news/home"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `코박뉴스` }), window.open('https://cobak.co.kr/news/home')]
                    }}
                  >
                    📰 <strong>코박뉴스</strong> 가상화폐 뉴스피드
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.tokenpost.kr/breaking"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `토큰포스트` }), window.open('https://www.tokenpost.kr/breaking')]
                    }}
                  >
                    📰 <strong>토큰포스트</strong> 가상화폐 미디어
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.blockmedia.co.kr/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `블록미디어` }), window.open('https://www.blockmedia.co.kr/')]
                    }}
                  >
                    📰 <strong>블록미디어</strong> 가상화폐 미디어
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://dstreet.io/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `디스트리트` }), window.open('https://dstreet.io/')]
                    }}
                  >
                    📰 <strong>디스트리트</strong> 가상화폐 미디어
                  </a>
                </div>
              </div>


              <header>
                <strong>추천 온체인데이터 링크</strong>
              </header>
              <div style={{ padding: '1rem' }}>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.ubcindex.com/indexes/IDX.UPBIT.UBMI"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `업비트 UBCI` }), window.open('https://www.ubcindex.com/indexes/IDX.UPBIT.UBMI')]
                    }}
                  >
                    📈 <strong>업비트 UBCI</strong> 시장 인덱스 분석
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://coinmarketcap.com/ko/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `코인마켓캡` }), window.open('https://coinmarketcap.com/ko/')]
                    }}
                  >
                    ⚔ <strong>코인마켓캡</strong> 전세계 거래소 차트
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.coingecko.com/ko"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `코인개코` }), window.open('https://www.coingecko.com/ko')]
                    }}
                  >
                    🐸 <strong>코인개코</strong> 암호화폐 통계
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://cryptoquant.com/overview/btc-exchange-flows"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `크립토퀀트` }), window.open('https://cryptoquant.com/overview/btc-exchange-flows')]
                    }}
                  >
                    🐳 <strong>크립토퀀트</strong> 온체인 차트
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://glassnode.com/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `glassnode` }), window.open('https://glassnode.com/')]
                    }}
                  >
                    🚨 <strong>Glassnode</strong> 온체인 차트
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://xangle.io/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `쟁글` }), window.open('https://xangle.io/')]
                    }}
                  >
                    🔎 <strong>쟁글</strong> 재단별 공시알림
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://coin360.com/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `코인360` }), window.open('https://coin360.com/')]
                    }}
                  >
                    🌎 <strong>코인360</strong> 시총거래 토탈맵
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://btc.com/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `BTC.COM` }), window.open('https://btc.com/')]
                    }}
                  >
                    💎 <strong>BTC.COM</strong> 익스플로러
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://etherscan.io/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `이더스캔` }), window.open('https://etherscan.io/')]
                    }}
                  >
                    💎 <strong>이더스캔</strong> 익스플로러
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.tokenterminal.com/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `토큰터미널` }), window.open('https://www.tokenterminal.com/')]
                    }}
                  >
                    💰 <strong>토큰터미널</strong> 디파이&amp;랜딩
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.bybt.com/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `bybt` }), window.open('https://www.bybt.com/')]
                    }}
                  >
                    🌨️ <strong>BYBT</strong> 선물만기 및 GBTC
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://kr.investing.com/futures-expiration-calendar/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `CME expiration calendar` }), window.open('https://kr.investing.com/futures-expiration-calendar/')]
                    }}
                  >
                    📆 <strong>CME</strong> 선물만기 확인
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://ko.coinjinja.com/events/time/this_week"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Coinjinja calendar` }), window.open('https://ko.coinjinja.com/events/time/this_week')]
                    }}
                  >
                    🗃️ <strong>Coinjinja</strong> STO/ICO 일정
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://cryptorank.io/upcoming-ico"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `CRYPTORANK calendar` }), window.open('https://cryptorank.io/upcoming-ico')]
                    }}
                  >
                    📌 <strong>CRYPTORANK</strong> IDO/IEO 일정
                  </a>
                </div>
              </div>

              <header>
                <strong>추천 봇 링크</strong>
              </header>
              <div style={{ padding: '1rem' }}>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://twitter.com/whale_alert"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Whale Alert` }), window.open('https://twitter.com/whale_alert')]
                    }}
                  >
                    🐳 <strong>Whale Alert</strong> 고래지갑 이동알림
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/s/BinanceLiquidations"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `BinanceLiquidations` }), window.open('https://t.me/s/BinanceLiquidations')]
                    }}
                  >
                    💥 <strong>바이낸스 선물알림</strong> 청산 알림
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/DropTheBitt"
                    target="_blank"
                    style={{ color: 'yellow' }}
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `BinanceLiquidations` }), window.open('https://t.me/DropTheBitt')]
                    }}
                  >
                    🌏 <strong>드랍더비트</strong> 트윗 자동한글번역
                  </a>
                </div>
              </div>

              <header>
                <strong>추천 텔레그램 링크</strong>
              </header>
              <div style={{ padding: '1rem' }}>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/mbmpostcom"
                    target="_blank"
                    style={{ color: 'yellow' }}
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `MBMPOST 소식방` }), window.open('https://t.me/mbmpostcom')]
                    }}
                  >
                    🔥 <strong>MBMPOST</strong> 호재·악재·속보
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/zefacoin"
                    style={{ color: 'yellow' }}
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `제파 텔레그램` }), window.open('https://t.me/zefacoin')]
                    }}
                  >
                    🚀 <strong>제파의 블로그</strong> 가상화폐 소식방
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/enjoymyhobby"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `취미생활방 텔레그램` }), window.open('https://t.me/enjoymyhobby')]
                    }}
                  >
                    🍹 <strong>취미생활방</strong> 가상화폐 소식방
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/coinkokr"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `코인코 텔레그램` }), window.open('https://t.me/coinkokr')]
                    }}
                  >
                    🪂 <strong>코인코</strong> 중요공지 알림방
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/shrimp_notice"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `새우잡이어선 텔레그램` }), window.open('https://t.me/shrimp_notice')]
                    }}
                  >
                    🦐 <strong>새우잡이어선</strong> 중요공지 알림방
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/xvgwhitedog2"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `하양이 아빠` }), window.open('https://t.me/xvgwhitedog2')]
                    }}
                  >
                    🐶 <strong>하양이 아빠</strong> 코인뉴스 정리
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/Ugh_HH"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `팩트시급 김으악` }), window.open('https://t.me/Ugh_HH')]
                    }}
                  >
                    👨‍🚀 <strong>팩트시급 김으악</strong> 코인뉴스 소식방
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/dogeland01"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `코인갤러리 소식방` }), window.open('https://t.me/dogeland01')]
                    }}
                  >
                    🐮 <strong>코인갤러리</strong> 비트코인 시황분석방
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/WeCryptoTogether"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `코인가치투자 정보대화방` }), window.open('https://t.me/WeCryptoTogether')]
                    }}
                  >
                    🙌 <strong>코인같이투자</strong> 정보대화방
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://t.me/samcaptain"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `XABCD 코인대화방` }), window.open('https://t.me/samcaptain')]
                    }}
                  >
                    🐯 <strong>XABCD</strong> 코인대화방
                  </a>
                </div>
              </div>

              <header>
                <strong>추천 유튜브 링크</strong>
              </header>
              <div style={{ padding: '1rem', marginBottom: '2rem' }}>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.youtube.com/channel/UCTWNsSbK8yELlYjm68eWv0w"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Youtuber 엘리TV님` }), window.open('https://www.youtube.com/channel/UCTWNsSbK8yELlYjm68eWv0w')]
                    }}
                    style={{ color: 'yellow' }}
                  >
                    🌟 <strong>엘리TV님 유튜브</strong> 시황분석 방송♥
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.youtube.com/channel/UCSE9OUP252diepZef3XqeLA"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Youtuber XABCD님` }), window.open('https://www.youtube.com/channel/UCSE9OUP252diepZef3XqeLA')]
                    }}
                  >
                    🐯 <strong>XABCD님 유튜브</strong> 선물방송♥
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.youtube.com/channel/UC3w3gZSKAWZ-nSvWEfQsMzw"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Youtuber 나스닥다우존스님` }), window.open('https://www.youtube.com/channel/UC3w3gZSKAWZ-nSvWEfQsMzw')]
                    }}
                  >
                    🏹 <strong>나스닥다우존스 MACD 공부</strong> 유튜브
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.youtube.com/channel/UC9KQaCA_EMobJUxZszQ4wlg"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Youtuber 박호두님` }), window.open('https://www.youtube.com/channel/UC9KQaCA_EMobJUxZszQ4wlg')]
                    }}
                  >
                    🌝 <strong>박호두</strong> 비트코인 선물 유튜브
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.youtube.com/channel/UC0RgMeINDkir1xAxpfsppjA"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Youtuber RT7팀` }), window.open('https://www.youtube.com/channel/UC0RgMeINDkir1xAxpfsppjA')]
                    }}
                  >
                    🏰 <strong>RT7</strong> 트레이닝팀 유튜브
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.youtube.com/watch?v=9nh7xSO6cFI"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Youtuber 사또님` }), window.open('https://www.youtube.com/watch?v=9nh7xSO6cFI')]
                    }}
                  >
                    🦸‍♂️ <strong>사또</strong> 비트코인 선물 유튜브
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://www.youtube.com/channel/UCMdI0q61jS3Ni2URTNZiC4A"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Youtuber 김단타님` }), window.open('https://www.youtube.com/channel/UCMdI0q61jS3Ni2URTNZiC4A')]
                    }}
                  >
                    🍙 <strong>김단타</strong> 비트코인 선물 유튜브
                  </a>
                </div>
              </div>

              <header>
                <strong>추천 유틸리티</strong>
              </header>
              <div style={{ padding: '1rem', marginBottom: '2rem' }}>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="http://webtool.cusis.net/stock-calculator-add/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `물타기불타기 계산기` }), window.open('http://webtool.cusis.net/stock-calculator-add/')]
                    }}
                  >
                    🧮 <strong>물타기·불타기</strong> 계산기
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://miningcalc.kr/calc/eth"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `이더리움 채산성 계산기` }), window.open('https://miningcalc.kr/calc/eth')]
                    }}
                  >
                    💎 <strong>이더리움 채굴 채산성</strong> 계산기
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://ultrasound.money/"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `ultrasound` }), window.open('https://ultrasound.money/')]
                    }}
                  >
                    🔥 <strong>이더리움 소각</strong> 확인
                  </a>
                </div>
                <div style={{ padding: '0.5rem 0' }}>
                  <a
                    href="https://txstreet.com/v/eth-btc"
                    target="_blank"
                    onClick={e => {
                      return [e.stopPropagation(), e.preventDefault(), ReactGA.event({ category: 'OutLink', action: `OutLink`, label: `Txstreet` }), window.open('https://txstreet.com/v/eth-btc')]
                    }}
                  >
                    🚊 <strong>Txstreet</strong> 블록거래
                  </a>
                </div>
              </div>

            </Block>
            
          </Page.Grid>
            
        </>
      ) : null}

    </Page>
  )
}

export default Home
